import './App.css'
import Header from './views/Header'
import Leftmenu from './views/LeftMenu/Leftmenu'
import ReviewMyKitchen from './views/ReviewMyKitchen'
import Button from './components/Button'
import HowToNavigate from './views/HowToNavigate'
import DOMHandler from './hooks/DOMHandler'
import Zoomout from './views/Zoomout'
import Callouts from './views/Callouts'
import cartContext from './store/cart-context'
import React, { useContext } from 'react'
import CustomeIcon from './components/CustomeIcon'
import { useGlobalContext } from './services/DataMain'
import { use3DContext } from './store/threedProvider'
import Hotspots from './views/Hotspots'
// import RadioButton from './views/RadioButton'
import PopUp from './views/PopUp'
import WhiteHotspot from './views/WhiteHotspot'
// import Landingzonepopup from './views/Landingzonepopup'

const App = () => {
  const DOMHandlerHelper = DOMHandler()
  const cartCtx = useContext(cartContext)
  const { menuList,popUp } = useGlobalContext() || {}
  const productStateSelectContext = use3DContext().productStateSelectContext
  window.productStateSelectContextGlobal = productStateSelectContext;
  // console.log('App Called');
  // console.log("DOMHandlerHelper.calloutInfo",DOMHandlerHelper.calloutInfo);

  const handleKitchenNavigation = ()=>{
    document.location.href = window.sharpthirtyURL
  }

  return (
    <>
      <Header></Header>

      {cartCtx?.items.length > 0 && (
        <ReviewMyKitchen
          // cartUpdate = {DOMHandlerHelper.updateCart}
          myKitchenPopupVisibility={DOMHandlerHelper.myKitchenPopupVisibility}
          reviewMyKitchenFunc={DOMHandlerHelper.handleMyKitchenVisibility}
        ></ReviewMyKitchen>
      )}

      <Leftmenu
        mainMenuVisibility={DOMHandlerHelper.mainMenuVisibility}
        mainMenuSowHideFunc={DOMHandlerHelper.handlehMainMenuVisibility}
        mainAccordionShowHide={DOMHandlerHelper.accordionExpand}
        mainAccordionFunc={DOMHandlerHelper.handleAccordionExpand}
        addToCartHandlerFunc={DOMHandlerHelper.handleAddItemToCart}
        removeCartHandlerFunc={DOMHandlerHelper.handleRemoveItemToCart}
        productCardFunc={DOMHandlerHelper.productCardClicked}
        productStateSelectContext={productStateSelectContext}

        // selectProdPlacement={DOMHandlerHelper.selectProductPlacement}
        
        productCardPopUpclick={DOMHandlerHelper.productCardClicked}

        closeRadioPopUpfunc={DOMHandlerHelper.closeRadiobtn}

      ></Leftmenu>

      <HowToNavigate
        howToNavigatePopupVisibility={
          DOMHandlerHelper.howToNavigatePopupVisibility
        }
        howToNavigateFunc={DOMHandlerHelper.handlehowToNavigateVisibility}
      ></HowToNavigate>

      {/* <Button>Zoom Out</Button> */}

      {/* <Callouts mainAccordionShowHide={DOMHandlerHelper.accordionExpand} mainAccordionFunc={DOMHandlerHelper.handleAccordionExpand} clickFunction={DOMHandlerHelper.ZoomOutreset}></Callouts> */}

      {/* <Zoomout buttonStyClass="zoomOutBtn" zoomClass="zoomOutImg" clickFunction={DOMHandlerHelper.ZoomOutreset}></Zoomout> */}
      {/* {console.log()} */}

      {/* <div id="productCategoryHotspot" className='productCategoryHotspot' style={{ display: DOMHandlerHelper.productCategoryHotspot ? 'block' : 'none' }}> */}
      <div id="productCategoryHotspot" className='productCategoryHotspot'>
        {menuList &&
          menuList?.map((menuCategoryData, menuCategoryIndex) => {

            // console.log("the data inside the menuCategory is", menuCategoryData);
              var nameOf3dObjData;
              var nameOf3dObj_right;
              var pedestalsTextUpdate;
              if(menuCategoryData.id == 'wallOvenCategory' && productStateSelectContext.wallOvenPosition == 'zoneThree'){
                // console.log('hotspot calledddddddddddddddddddddddd....................');
                // console.log('menuCategoryData.id', menuCategoryData.id);
                // console.log('productStateSelectContext', productStateSelectContext);
                nameOf3dObjData = menuCategoryData.nameOf3dObj_right
              }
              
              else if( menuCategoryData.id == 'underTheCounterPedestalsCategory' && productStateSelectContext.pedestalsPosition == "zoneSeven"){
                nameOf3dObjData = menuCategoryData.nameOf3dObj_right;
                // console.log("productStateSelectContext",menuCategoryData.id)
                // console.log("nameOf3dObjData",nameOf3dObjData)
              }
              else if(menuCategoryData.id == 'underTheCounterPedestalsCategoryRight' && productStateSelectContext.pedestalsPosition == "zoneThree"){
                // nameOf3dObjData = menuCategoryData.nameOf3dObj;
                // hotspotTextMain_zoneThree = menuCategoryData.hotspotTextMain_zoneThree;
              }
              // else if(menuCategoryData.id == 'underTheCounterPedestalsCategory' && productStateSelectContext.pedestalsPosition == "zoneThree"){
              //   menuCategoryData.hotspotTextMain = menuCategoryData.hotspotTextMain_zoneThree
              //   // console.log("menuCategoryData.hotspotTextMain",menuCategoryData.hotspotTextMain);
              //   // console.log("menuCategoryData.hotspotTextMain",menuCategoryData);
                  
              // }
               else {
                nameOf3dObjData = menuCategoryData.nameOf3dObj
                pedestalsTextUpdate = menuCategoryData.hotspotTextMain_zoneThree
                // if(menuCategoryData.id == "underTheCounterPedestalsCategory"){
                //   nameOf3dObj_right = menuCategoryData.nameOf3dObj_right
                // }
              }


            return (

              <React.Fragment key={menuCategoryIndex} >
                <Hotspots
                  index={menuCategoryIndex}
                  hotspotsDataText={menuCategoryData.hotspotTextMain}
                  pedestalsTextUpdate={pedestalsTextUpdate}
                  // hotspotTextMain_zoneThree={menuCategoryData.hotspotTextMain_zoneThree}
                  id={menuCategoryData.id}
                  hotspotId={menuCategoryData.id+'hotspotId'}
                  mainAccordionFunc={DOMHandlerHelper.handleAccordionExpand}
                  productStateSelectContext={productStateSelectContext}
                  camSequence={menuCategoryData.camSequence}
                  camSequencetwo={menuCategoryData.camSequencetwo}
                  nameOf3dObj={nameOf3dObjData}
                  // nameOf3dObj_right={nameOf3dObj_right}
                  // change

                  hotspotXoffset={menuCategoryData.hotspotXoffset}
                  hotspotYoffset={menuCategoryData.hotspotYoffset}
                  hotspotminFadeAngleDeg={menuCategoryData.hotspotminFadeAngleDeg}
                  hotspotmaxFadeAngleDeg={menuCategoryData.hotspotmaxFadeAngleDeg}
                  // isactive = {DOMHandlerHelper.productCategoryHotspot ? true : false }
                  menuItemLength={menuCategoryData?.items?.length}
                  menuItems={menuCategoryData?.items}
                ></Hotspots>

              </React.Fragment>
            )
          }
          )
        }
      </div>

      {/* <div id="internalCalloutsAndHotspots" className='internalCalloutsAndHotspots' style={{ display: DOMHandlerHelper.calloutInfo ? 'block' : 'none' }}> */}
      <div id="internalCalloutsAndHotspots" className='internalCalloutsAndHotspots'>
        {menuList &&
          menuList?.map((menuCategory, menuCategoryIndex) => {
            return (
              menuCategory &&
              menuCategory?.items?.map((menuItem, menuItemIndex) => {

                // if(menuCategoryData.title == 'wallOvenCategory' && productStateSelectContext.wallOvenPosition == 'zoneThree'){
                //   console.log('hotspot calledddddddddddddddddddddddd....................');
                //   console.log('menuCategoryData.id', menuCategoryData.id);
                //   console.log('productStateSelectContext', productStateSelectContext);
                //   nameOf3dObjData = menuCategoryData.nameOf3dObj_right
                // }

                // console.log('productStateSelectContext',productStateSelectContext)
                // console.log('menuItem',menuItem)
                // console.log('menuItem.hotspots',menuItem.hotspots)
                // console.log('menuItem.hotspots[4].nameOf3dObj',menuItem.hotspots[4].nameOf3dObj)


              //   if(menuCategory.id === "wallOvenCategory"){
              //   //   console.log('menuItem.hotspots[4].nameOf3dObj',menuItem.hotspots[4].nameOf3dObj )
              //   }

              //   if(menuCategory.id === "wallOvenCategory"){
              //   if(menuItem.hotspots[4].nameOf3dObj != "" && menuItem.hotspots[4].nameOf3dObj === "Walloven_Location_HOTSPOT_01"){
                   
              //     menuTitleId = menuCategory.id
              //   }
              //   else{
                   
              //     menuTitleId = menuItem.title + '-hotspot';
              //   }
              // }

                return (
                  <React.Fragment key={menuItemIndex}>
                    <Callouts
                      menuItemCallout={menuItem.callouts}
                      menuItemIndex={menuItemIndex}
                      hotspotVisibility={true}
                      // hotspotsData={menuItem.hotspots}
                      id={menuItem.title + '-callout'}
                      handleCalloutsInfo={DOMHandlerHelper.handleCalloutsInfo}
                      calloutAccShowHide={DOMHandlerHelper.calloutAccExpand}
                      calloutAccFunc={DOMHandlerHelper.handleCalloutAccordion}
                      clickFunction={DOMHandlerHelper.ZoomOutreset}
                      categoryCamSequence={menuCategory.camSequence}
                      productStateSelectContext={productStateSelectContext}

                    ></Callouts>

                    <Hotspots
                      hotspotsData={menuItem.hotspots} 
                      id={menuItem.title + '-hotspot'}
                      // id={menuTitleId}
                      // productCardFunc={DOMHandlerHelper.productCardClicked}
                      mainAccordionShowHide={DOMHandlerHelper.accordionExpand}
                      mainAccordionFunc={DOMHandlerHelper.handleAccordionExpand}
                      productStateSelectContext={productStateSelectContext}
                      menuItemCallout={menuItem.callouts}
                      // menuItemIndex={menuItemIndex}
                      hotspotVisibility={true}
                      // hotspotsData={menuItem.hotspots}
                      // id={menuItem.title + '-callout'}
                      handleCalloutsInfo={DOMHandlerHelper.handleCalloutsInfo}
                      calloutAccShowHide={DOMHandlerHelper.calloutAccExpand}
                      calloutAccFunc={DOMHandlerHelper.handleCalloutAccordion}
                      clickFunction={DOMHandlerHelper.ZoomOutreset}
                      camSequence={menuCategory.camSequence}
                      camSequencetwo={menuCategory.camSequencetwo}
                      internalHotspotClickHandler={DOMHandlerHelper.hotspotClick}
                      // index={menu_index}
                      id1={menuCategory.id}
                      accordId={menuCategory.id+"cam"}
                      iconName="caret-forward"
                      menuItemLength={menuCategory.items?.length}
                      menuItems={menuCategory?.items}
                      CategoryTitile={menuCategory.title}
                      // ClickAcc={props.mainAccordionFunc}
                      // camSequence={menuCategory.camSequence}
                      // secondcamSequence={menuCategory.camSequencetwo}
                      // mainAccordionShowHide={props.mainAccordionShowHide}
                      // productStateSelectContext={props.productStateSelectContext}
                      // categoryId={menuCategory.id+'newData'}
                    ></Hotspots>

                      {/* white hotspot code is here only */}
                      {/* {menuItem &&
                        menuItem?.hotspots?.map(
                          (menuItemHotspot, menuItemhotspotIndex) => {

                            return (
                              <React.Fragment key={menuItemhotspotIndex}>

                              <WhiteHotspot
                              hotspotsData={menuItemHotspot.callouts} 
                            //  id={menuItemHotspot.id + '-hotspot'}
                             id={menuItem.title+"-"+menuItemHotspot.hotspotText.replace(/ /g, '') + '-WhiteHotspot'}
                            //  mainAccordionShowHide={DOMHandlerHelper.accordionExpand}
                            //  mainAccordionFunc={DOMHandlerHelper.handleAccordionExpand}
                             productStateSelectContext={productStateSelectContext}
                             menuItemCallout={menuItemHotspot.callouts}
                             hotspotVisibility={true}
                             handleCalloutsInfo={DOMHandlerHelper.handleCalloutsInfo}
                             calloutAccShowHide={DOMHandlerHelper.calloutAccExpand}
                             calloutAccFunc={DOMHandlerHelper.handleCalloutAccordion}
                            //  clickFunction={DOMHandlerHelper.ZoomOutreset}
                            //  camSequence={menuCategory.camSequence}
                            //  camSequencetwo={menuCategory.camSequencetwo}
                            //  internalHotspotClickHandler={DOMHandlerHelper.hotspotClick}
                             id1={menuCategory.id}
                            //  accordId={menuCategory.id+"cam"}
                             iconName="caret-forward"
                            //  menuItemLength={menuCategory.items.length}
                            //  menuItems={menuCategory.items}
                            //  CategoryTitile={menuCategory.title}
                              >
                              </WhiteHotspot>
                              </React.Fragment>
                              // productStateSelectContext[productStateSelectContext.cooktopCategory]=menuItem.id;
                            )
                          },
                        )} */}

                    <div
                      className="internalCallouts"
                      id={menuItem.title + '-calloutContainer'}
                    >
                      {menuItem &&
                        menuItem?.hotspots?.map(
                          (menuItemHotspot, menuItemhotspotIndex) => {

                            return (
                              <React.Fragment key={menuItemhotspotIndex}>
                                <Callouts
                                  menuItemCallout={menuItemHotspot.callouts}
                                  // menuItemCallout={menuItem.callouts}
                                  menuItemIndex={menuItemhotspotIndex}
                                  key={menuItemhotspotIndex}
                                  hotspotVisibility={false}
                                  id={
                                    menuItem.title +
                                    '-' +
                                    menuItemHotspot.hotspotText.replace(/\s/g, '')
                                  }
                                  handleCalloutsInfo={
                                    DOMHandlerHelper.handleCalloutsInfo
                                  }
                                  calloutAccShowHide={
                                    DOMHandlerHelper.calloutAccExpand
                                  }
                                  calloutAccFunc={
                                    DOMHandlerHelper.handleCalloutAccordion
                                  }
                                  clickFunction={DOMHandlerHelper.ZoomOutreset}
                                  categoryCamSequence={menuCategory.camSequence}
                                  productStateSelectContext={productStateSelectContext}
                                ></Callouts>

                                 {/* passing this for the accordion hotspot's */}
                              
                              </React.Fragment>
                              // productStateSelectContext[productStateSelectContext.cooktopCategory]=menuItem.id;
                            )
                          },
                        )}
                    </div>
                  </React.Fragment>
                )
              })
            )
          })}
      </div>

      <div className='zoomOutMob'
        style={{ display: !DOMHandlerHelper.calloutInfo ? 'block' : 'none' }}
      >
        <Zoomout
          clickFunction={DOMHandlerHelper.ZoomOutreset}
          productStateSelectContext={productStateSelectContext}
        ></Zoomout>
        <Button
          classList="informationIcon"
          clickFunction={DOMHandlerHelper.handleCalloutsInfoBtnHandler}

        >
          <CustomeIcon src="./images/info.png"></CustomeIcon>
        </Button>
      </div>

      <div className='navigationMob'>
          <Button
            classList="navigateButtonMob"
            clickFunction={handleKitchenNavigation}
          >

          <CustomeIcon src="./images/arrow_new.svg" classList="arrowmob"></CustomeIcon>
          <p>Go to 30" 3D Showroom</p>
          </Button>

          <Button
          data={productStateSelectContext}
            clickFunction={DOMHandlerHelper.ZoomOutreset}
            classList="zoomoutButtonNew"
          >

          <CustomeIcon src="./images/zoomOutIcon.svg" classList="zoomoutMobIcon"></CustomeIcon>
            <p>Zoom out to all appliances </p>
          </Button>
          
      </div>


      {/* popup UI */}

      {/* <PopUp
        closeRadioPopUpfunc={DOMHandlerHelper.closeRadiobtn}
        // radioBtnfuncSeven={DOMHandlerHelper.handleRadioBtnzoneSeven}
        // radioBtnfuncThree={DOMHandlerHelper.handleRadioBtnzoneThree}

        selectProdPlacement={DOMHandlerHelper.selectProductPlacement}

        productStateSelectContext={productStateSelectContext}

        // mainAccordionFunc={DOMHandlerHelper.handleAccordionExpand}
        popUp={popUp}
        
      ></PopUp> */}

    </>
  )
}

export default App
